export default __webpack_public_path__ + "static/media/digital-marketing-360devpro.0c0c4573.svg";